import axios from '../axios/redditlikeApi'

const getReportsByUser = () => axios.get('/reports')

const getReportedPosts = (page, size) => axios.get('/reports/posts', {
  params: {
    page,
    size
  }
})

const getReportedComments = (page, size) => axios.get('/reports/comments', {
  params: {
    page,
    size
  }
})

const createReport = form => axios.post('/reports', form)

const updateArchive = (id, archived) => axios.patch(`/reports/${id}`, archived)

const deletePostReport = postId => axios.delete(`/reports/${postId}`)

const deleteCommentReport = commentId => axios.delete(`/reports/${commentId}`)

export default {
  getReportsByUser,
  getReportedPosts,
  getReportedComments,
  createReport,
  updateArchive,
  deletePostReport,
  deleteCommentReport
}
